export const repairOrderImageApi = 'wx/wechatrepairimage/' // wechatrepairserviceimage